// Centralized mapping of field names to i18n label keys for validation messages.
const fieldLabelKeyMap = {
  Username: 'shared:fields:username',
  Password: 'shared:fields:password',
  verifyCode: 'identityProvider:login:verifyOTPCodeHeader',
  Answer: 'identityProvider:fraudControl:challenge:answer',
  OldPassword: 'identityProvider:changePassword:oldPassword',
  NewPassword: 'identityProvider:changePassword:newPassword',
  ConfirmPassword: 'identityProvider:changePassword:confirmPassword',
  ConfirmUserName: 'identityProvider:changeUsername:confirmUsername',
  // Add more fields as needed, e.g.:
  // Email: 'shared:fields:email'
};

export default fieldLabelKeyMap;